import React, { useState, useRef, useEffect } from "react";
import { isRemoteLockVehicle } from "../../../../utils/keyless";
import Slider from "react-slick";
import {
  Grid,
  Typography,
  Box,
  Divider,
  Collapse,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IBookingCreateInput, ICamperVanDetails, IVehicle, IVehicleImage, IVehiclePriceGroup, IVehicleType } from "../../../../reducers/bookings/types";
import { getFeatureTypeIcon, getVehicleTypeIcon, toCurrency } from "../../../utils";
import { capitalizeFirstLetter } from "../utils";
import { useSelector } from "react-redux";
import { IAppState } from "../../../../store";
import CheckRounded from "@material-ui/icons/CheckCircleRounded";
import CamperVanDetailModal from "./CamperVanDetailsModal";
import { useSnackBar } from "../../../SnackBarContext/SnackBarContext";
import { SnackBarVariant } from "../../../SnackbarWrapper/SnackbarWrapper";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "75%",
    maxWidth: 1400,
    backgroundColor: "#fff",
    borderRadius: "16px 0 0 16px",
    height: "100vh",
    overflowY: "auto",
    marginLeft: "auto",
    transition: "all 0.5s ease",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      borderRadius: 0,
    },
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ddd",
      borderRadius: 3,
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(3, 5),
    borderBottom: "1px solid #f0f0f0",
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  vehicleTitle: {
    fontWeight: 700,
    fontSize: "1.8rem",
    color: "#111",
  },

  leftPanel: {
    padding: theme.spacing(2, 3),
  },
  rightPanel: {
    padding: theme.spacing(2, 3),
  },

  sliderWrapper: {
    position: "relative",
    borderRadius: 14,
    overflow: "hidden",
    marginBottom: theme.spacing(2),
  },
  sliderImage: {
    width: "100%",
    height: 420,
    objectFit: "contain",
    borderRadius: 14,
    [theme.breakpoints.down("sm")]: {
      height: 200,
    }
  },
  arrowBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 5,
    background: "rgba(255,255,255,0.3)",
    backdropFilter: "blur(8px)",
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.4)",
    color: "#000",
    "&:hover": { background: "rgba(255,255,255,0.6)" },
  },
  leftArrow: { left: 10 },
  rightArrow: { right: 10 },

  thumbWrapper: {
    marginTop: theme.spacing(1),
    "& img": {
      height: 60,
      width: "100%",
      objectFit: "contain",
      borderRadius: 8,
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
  },

  specBox: {
    display: "flex",
    overflowX: "auto",
    paddingBottom: theme.spacing(1.5),
    marginTop: theme.spacing(4),
    "&::-webkit-scrollbar": { height: 6 },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ccc",
      borderRadius: 3,
    },
    justifyContent: "space-around",
  },
  specItem: {
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 1),
    border: "1px solid #eee",
    borderRadius: 12,
    backgroundColor: "#fafafa",
    marginRight: theme.spacing(1.5),
    "&:hover": {
      backgroundColor: "#f3f3f3",
    },
  },
  specLabel: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#111",
    marginLeft: theme.spacing(0.5),
  },

  sectionTitle: {
    fontWeight: 700,
    fontSize: "20px",
    margin: theme.spacing(4, 0, 1.5),
    color: "#000",
  },

  addonGrid: {
    marginTop: theme.spacing(2),
  },
  addonCard: {
    border: "1px solid #eee",
    borderRadius: 12,
    textAlign: "center",
    padding: theme.spacing(3),
    backgroundColor: "#fafafa",
    position: "relative",
  },
  addonBadge: {
    position: "absolute",
    top: 8,
    right: 12,
    backgroundColor: "#111",
    color: "#fff",
    borderRadius: 12,
    fontSize: "0.7rem",
    padding: "2px 8px",
    fontWeight: 600,
  },
  addonIcon: {
    color: theme.palette.primary.main,
    fontSize: 34,
    marginBottom: theme.spacing(1),
  },

  counterBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(1.5),
  },
  counterBtn: {
    border: "1px solid #ccc",
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#eee",
    },
  },
  counterValue: {
    margin: theme.spacing(0, 1.5),
    fontWeight: 700,
    fontSize: "1rem",
  },

  footer: {
    position: "sticky",
    bottom: 0,
    left: "15%",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 6),
    minHeight: 72,
    borderTop: "1px solid #f0f0f0",
    zIndex: 10,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: 60,
      justifyContent: "space-between",
      padding: theme.spacing(2, 3),
    }
  },
  pageContent: {
    height: "calc(100vh - 72px)",
    overflowY: "auto",
    paddingBottom: 24,
  },
  ctaButton: {
    borderRadius: 40,
    padding: "12px 36px",
    fontWeight: 700,
    fontSize: 16,
    textTransform: "none",
    borderWidth: 2,
    borderColor: "#111 !important",
    color: "#111 !important",
    transition: "all 240ms cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(6px)",
    "&:hover": {
      borderColor: "#000",
      background: "rgba(0,0,0,0.04)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 1.5),
      fontSize: 14,
    }
  },
  ctaSelected: {
    background: "rgba(17, 17, 17, 0.9) !important",
    borderColor: "#000 !important",
    color: "#fff !important",
    "& $carIcon": { opacity: 0 },
    "& $checkIcon": { opacity: 1 },
    "&:hover": {
      background: "rgba(17, 17, 17, 1) !important",
      transform: "translateY(-1px)",
      boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
    },
  },

  carIcon: {
    fontSize: 22,
    opacity: 1,
    transition: "opacity .2s ease",
  },

  checkIcon: {
    fontSize: 22,
    opacity: 0,
    transition: "opacity .25s ease",
  },

}));

interface IVehicleSlideImage {
  vId: string;
  url: string
}
interface IProps {
  vehicle: IVehicle;
  images: IVehicleImage[];
  vehicleGroup: IVehiclePriceGroup;
  onSelectVehicle: (data: any, isIncrease: boolean, vehicleId?: string, smartCarOnly?: boolean) => void;
  totalPrice: string;
  values: IBookingCreateInput;
  showVehicleGroupPrices: boolean;
  smartCarOnly?: boolean;
}

const VehicleDetailDrawerContent: React.FC<IProps> = ({ vehicle, images, vehicleGroup, onSelectVehicle, totalPrice, values, showVehicleGroupPrices, smartCarOnly }) => {

  const classes = useStyles();
  const snackbar = useSnackBar();
  const { t } = useTranslation();
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const branchData = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.branches);

  const { vehicleDetailsSettings } = website;
  const authUser = useSelector((state: IAppState) => state.authReducer.user);
  const isBusinessCustomer = authUser && authUser.businesscustomers;
  const multipleVehicleBooking = !isBusinessCustomer ? (website.multipleVehicleBooking || false) : true;
  const { locale, currency } = website.organisation;
  const { country } = website.organisation.address;

  const [openSection, setOpenSection] = useState<string | null>("interior");
  const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
  const [openCamperVanModal, setOpenCamperVanModal] = useState<boolean>(false);
  const [camperVanDetails, setCamperVanDetails] = useState<ICamperVanDetails>();

  const mainSlider = useRef<Slider | null>(null);
  const thumbSlider = useRef<Slider | null>(null);
  const contactlessVehicle = vehicle.isContactless || isRemoteLockVehicle(vehicle)

  const vehicleImages = images.filter(img => img?.groupId === vehicleGroup.id && img?.vehicleId === vehicle.id);

  const handleToggle = (section: string) =>
    setOpenSection(openSection === section ? null : section);

  useEffect(() => {
    if (values.vehicleGroups && !selectedVehicles.length) {
      const selectedGroup = values.vehicleGroups.find(vg => vg.vehicleGroup === vehicleGroup.id);
      if (selectedGroup && selectedGroup.vehicleIds.length) {
        setSelectedVehicles(selectedGroup.vehicleIds);
      }
    }
  }, [selectedVehicles.length, values, vehicleGroup])

  const sliderSettings = {
    arrows: false,
    dots: false,
    infinite: vehicleImages.length > 1,
    speed: 600,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: thumbSlider.current!,
    cssEase: "linear",
    slidesToShow: 1
  };

  const thumbSettings = {
    slidesToShow: vehicleImages.length > 0 ? vehicleImages.length : 1,
    swipeToSlide: true,
    infinite: vehicleImages.length > 1,
    focusOnSelect: true,
    arrows: false,
    centerMode: true,
    asNavFor: mainSlider.current!,
  };

  return (
    <React.Fragment>
      <Box className={classes.pageContent}>
        <Grid container>
          {/* LEFT SIDE */}
          <Grid item xs={12} md={7} className={classes.leftPanel}>
            <Box className={classes.sliderWrapper}>
              {/* <IconButton
                className={`${classes.arrowBtn} ${classes.leftArrow}`}
                onClick={() => mainSlider.current?.slickPrev()}
              >
                <ChevronLeft />
              </IconButton>
              <IconButton
                className={`${classes.arrowBtn} ${classes.rightArrow}`}
                onClick={() => mainSlider.current?.slickNext()}
              >
                <ChevronRight />
              </IconButton> */}
              <Slider {...sliderSettings} ref={mainSlider}>
                {vehicleImages.length > 0 ? vehicleImages.map((img, i) => (
                  <img key={i} src={img.url} alt="vehicle" className={classes.sliderImage} />
                )) :
                  (
                    [1].map((_, i) => (
                      <img
                        key={i}
                        src={getVehicleTypeIcon(capitalizeFirstLetter(vehicle.bodyType))}
                        alt="vehicle"
                        className={classes.sliderImage}
                      />
                    ))
                  )
                }
              </Slider>
            </Box>

            <Box className={classes.thumbWrapper}>
              <Slider {...thumbSettings} ref={thumbSlider}>
                {vehicleImages.length > 0 ? vehicleImages.map((img, i) => (
                  <img key={i} src={img.url} alt={`thumb-${i}`} />
                )) : (
                  [1].map((_, i) => (
                    <img
                      key={i}
                      src={getVehicleTypeIcon(capitalizeFirstLetter(vehicle.bodyType))}
                      alt="vehicle"
                      className={classes.sliderImage}
                    />
                  ))
                )
                }
              </Slider>
            </Box>

            {/* Scrollable spec swatches */}
            {
              vehicleDetailsSettings.categories.specification.enabled && (
                <Box className={classes.specBox}>
                  {[
                    { icon: getFeatureTypeIcon("camperVan"), label: "Camper", visibility: vehicle.vehicleType === IVehicleType.CAMPER_VAN },
                    { icon: getFeatureTypeIcon("numberOfDoors"), label: `${vehicle.numberOfDoors} Door`, visibility: vehicleDetailsSettings?.categories.specification.fields.numberOfDoors },
                    { icon: getFeatureTypeIcon("numberOfSeats"), label: `${vehicle.numberOfSeats} Seats`, visibility: vehicleDetailsSettings?.categories.specification.fields.numberOfSeats },
                    { icon: getFeatureTypeIcon("fuelType"), label: vehicle.fuelType, visibility: vehicleDetailsSettings.categories?.specification.fields.fuelType },
                    { icon: getFeatureTypeIcon("transmission"), label: vehicle.transmission, visibility: vehicleDetailsSettings?.categories.specification.fields.transmission },
                  ].filter(item => item.visibility).map((s, i) => (
                    <Box
                      key={i}
                      className={classes.specItem}
                      style={{ cursor: s.label.toLowerCase().includes("camper") ? "pointer" : "default" }}
                      onClick={(e) => {
                        if (s.label.toLowerCase().includes("camper")) {
                          e.stopPropagation();
                          setOpenCamperVanModal(true);
                          setCamperVanDetails(vehicle.camperVanDetails);
                        }
                      }}
                    >
                      <img src={s.icon} alt={s.label} style={{ width: 16, height: 16 }} />
                      <Typography className={classes.specLabel}>{s.label}</Typography>
                    </Box>
                  ))}
                </Box>
              )
            }

            {/* This will be picked after demo */}
            {/* <Typography className={classes.sectionTitle}>Add-ons & Extras</Typography>
        <Grid container spacing={3} className={classes.addonGrid}>
          {addons.map((a) => (
            <Grid item xs={12} sm={6} key={a.name}>
              <Box className={classes.addonCard}>
                <Box className={classes.addonBadge}>
                  {addonCounts[a.name] || 0} left
                </Box>
                <CheckCircle className={classes.addonIcon} />
                <Typography variant="h2" style={{ fontWeight: 600 }}>{a.name}</Typography>
                <Typography>{a.desc}</Typography>
                <Typography variant="h2" style={{ fontWeight: 600 }}>{a.price}</Typography>
                <Box className={classes.counterBox}>
                  <Box
                    className={classes.counterBtn}
                    onClick={() => handleCounter(a.name, false)}
                  >
                    <Remove fontSize="small" />
                  </Box>
                  <Typography className={classes.counterValue}>
                    {addonCounts[a.name] || 0}
                  </Typography>
                  <Box
                    className={classes.counterBtn}
                    onClick={() => handleCounter(a.name, true)}
                  >
                    <Add fontSize="small" />
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid> */}
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={5} className={classes.rightPanel}>
            <Typography variant="h1" style={{ fontWeight: 700, marginBottom: 8 }}>
              {`${vehicle.make} ${vehicle.model}`}
            </Typography>
            <Typography variant="caption">
              {/* description */}
            </Typography>

            {
              vehicleDetailsSettings.categories.specification.enabled && vehicleDetailsSettings.categories.specification.fields.color && (
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #eee",
                    borderRadius: 10,
                    padding: "16px 24px",
                    marginTop: 16,
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Box
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: "50%",
                      marginRight: 16,
                      backgroundColor: vehicle.colour,
                    }}
                  />
                  <Typography variant="body1" style={{ fontWeight: 600 }}>
                    {capitalizeFirstLetter(vehicle.colour)}
                  </Typography>
                </Box>
              )
            } 

            {
              showVehicleGroupPrices && (
                <Box
                  style={{
                    border: "1px solid #f0f0f0",
                    borderRadius: 14,
                    padding: 24,
                    marginTop: 32,
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Typography variant="h1" style={{ fontWeight: 700, marginBottom: 10 }}>
                    {totalPrice}
                  </Typography>

                  <Typography variant="h3" >
                    Deposit: {toCurrency(vehicleGroup.deposit, currency, locale)}
                  </Typography>



                  {/* This will be picked after demo */}
                  {/* <Typography variant="h3">Contract Length: 24 months</Typography>
              <Divider style={{ margin: "16px 0" }} />
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleToggle("priceInclusions")}
              >
                <Typography variant="h2" style={{ fontWeight: 600 }}>
                  What’s included
                </Typography>
                {openSection === "priceInclusions" ? <ExpandLess /> : <ExpandMore />}
              </Box>
              <Collapse in={openSection === "priceInclusions"}>
                <ul style={{ marginTop: 12 }}>
                  <li style={{ marginBottom: 10 }}>Insurance</li>
                  <li style={{ marginBottom: 10 }}>Maintenance</li>
                  <li style={{ marginBottom: 10 }}>Roadside Assistance</li>
                </ul>
              </Collapse> */}
                </Box>
              )
            }

            {
              vehicle.safetyAndTechnicalFeatures && vehicleDetailsSettings.categories.safetyAndTech.enabled && (
                <React.Fragment >
                  <Divider style={{ margin: openSection === "safetyAndTech" ? "30px 0 16px" : "16px 0" }} />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggle("safetyAndTech")}
                  >
                    <Typography variant="h2" style={{ fontWeight: 600 }}>
                      Safety & Technical Features
                    </Typography>
                    {openSection === "safetyAndTech" ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={openSection === "safetyAndTech"}>
                    <ul style={{ marginTop: 12 }}>
                      {vehicle.safetyAndTechnicalFeatures.map((item) => (
                        <li key={item} style={{ marginBottom: 10 }}>{item}</li>
                      ))}
                    </ul>
                  </Collapse>
                </React.Fragment>
              )
            }

            {
              vehicle.interiorFeatures && vehicleDetailsSettings.categories.interiorFeatures.enabled && (
                <React.Fragment >
                  <Divider style={{ margin: openSection === "interiorFeatures" ? "30px 0 16px" : "16px 0" }} />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggle("interiorFeatures")}
                  >
                    <Typography variant="h2" style={{ fontWeight: 600 }}>
                      Interior Features
                    </Typography>
                    {openSection === "interiorFeatures" ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={openSection === "interiorFeatures"}>
                    <ul style={{ marginTop: 12 }}>
                      {vehicle.interiorFeatures.map((item) => (
                        <li key={item} style={{ marginBottom: 10 }}>{item}</li>
                      ))}
                    </ul>
                  </Collapse>
                </React.Fragment>
              )
            }

            {
              vehicle.exteriorFeatures && vehicleDetailsSettings.categories.exteriorFeatures.enabled && (
                <React.Fragment >
                  <Divider style={{ margin: openSection === "exteriorFeatures" ? "30px 0 16px" : "16px 0" }} />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggle("exteriorFeatures")}
                  >
                    <Typography variant="h2" style={{ fontWeight: 600 }}>
                      Exterior Features
                    </Typography>
                    {openSection === "exteriorFeatures" ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={openSection === "exteriorFeatures"}>
                    <ul style={{ marginTop: 12 }}>
                      {vehicle.exteriorFeatures.map((item) => (
                        <li key={item} style={{ marginBottom: 10 }}>{item}</li>
                      ))}
                    </ul>
                  </Collapse>
                </React.Fragment>
              )
            }

            {
              vehicle.features && vehicleDetailsSettings.categories.otherFeatures.enabled && (
                <React.Fragment >
                  <Divider style={{ margin: openSection === "features" ? "30px 0 16px" : "16px 0" }} />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggle("features")}
                  >
                    <Typography variant="h2" style={{ fontWeight: 600 }}>
                      Other Features
                    </Typography>
                    {openSection === "features" ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={openSection === "features"}>
                    <ul style={{ marginTop: 12 }}>
                      {vehicle.features.map((item) => (
                        <li key={item} style={{ marginBottom: 10 }}>{item}</li>
                      ))}
                    </ul>
                  </Collapse>
                </React.Fragment>
              )
            }
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.footer}>
        <Typography style={{ fontWeight: 700, fontSize: "1.2rem" }} color="primary">
          {showVehicleGroupPrices ? `Total: ${totalPrice}` : ""}
        </Typography>
        <Button
          variant="outlined"
          className={`${classes.ctaButton} ${vehicle?.id && selectedVehicles.includes(vehicle.id)
            ? classes.ctaSelected
            : ""
            }`}
          onClick={() => {
            const id = vehicle?.id;
            if (!id) return;
            if(smartCarOnly){
              if(!selectedVehicles.includes(id) && selectedVehicles.length > 0){
                if(contactlessVehicle){
                  snackbar({
                    message: t('snackBar:oneVehicleForContactless'),
                    variant: SnackBarVariant.INFORMATION
                  })
                } else{
                  snackbar({
                    message: t('snackBar:oneVehicleForNonContactless'),
                    variant: SnackBarVariant.INFORMATION
                  })
                }
                return;
              }
            } else {
              if(contactlessVehicle){
                if(!selectedVehicles.includes(id) && selectedVehicles.length > 0){
                  snackbar({
                    message: t('snackBar:contactlessVehicleCannotBeSelected'),
                    variant: SnackBarVariant.INFORMATION
                  })
                  return;
                }
              }
            }
            setSelectedVehicles(prev => {
              if (prev.includes(id)) {
                onSelectVehicle(vehicleGroup, false, id, contactlessVehicle);
                return multipleVehicleBooking ? prev.filter(v => v !== id) : [] ;
              } else {
                onSelectVehicle(vehicleGroup, true, id, contactlessVehicle);
                return multipleVehicleBooking ? [...prev, id] : [id]
              }
            });
          }}
          startIcon={
            vehicle?.id && selectedVehicles.includes(vehicle.id)
            && <CheckRounded className={classes.checkIcon} />

          }
        >
          {vehicle?.id && selectedVehicles.includes(vehicle.id)
            ? "Selected"
            : "Book this Vehicle"}
        </Button>
      </Box>
      {
        openCamperVanModal && (
          <CamperVanDetailModal
            open={openCamperVanModal}
            onClose={() => setOpenCamperVanModal(false)}
            camperVanDetails={camperVanDetails}
          />
        )
      }
    </React.Fragment>
  );
};

export default VehicleDetailDrawerContent;
